import React, { useRef, useState } from 'react';
import { Popover, Overlay, Button } from 'react-bootstrap'
import { diffWords } from 'diff'

import MdMath from '../components/MdMath';
import { nice_date } from '../utils';
import { Problema } from '../api/types';


interface IProps {
  problema: Problema
}


export default function BottoneVersioniProblema(props: IProps) {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <>
      <Button variant="info" className="mr-3 mb-2" type="button"
        title="Versioni del problema" onClick={() => setShow(!show)} ref={target}>
        <i className="fa fa-copy mr-1" aria-hidden="true" /> Versioni
      </Button>
      <Overlay
        placement="bottom"
        show={show}
        target={target.current}
      >
        {({ ...old }: any) => {
          return <Popover id={`versioni`} {...old}>
            <Popover.Title>
              <span className="mr-2">
                <i className="fa fa-times text-muted" onClick={() => setShow(false)} />
              </span>
                Versioni
              </Popover.Title>
            <Popover.Content>
              {props.problema.versioni.map((versione, idx) => {
                let elem = null;
                if (idx != 0) {
                  const old = props.problema.versioni[idx - 1];
                  const diff = diffWords(old.testo, versione.testo);
                  elem = diff.map((part, idx2) => {
                    const color = part.added ? 'success' :
                      part.removed ? 'danger' : null;
                    return color ? <span className={`text-${color}`} key={idx2}>{part.value}</span> : <React.Fragment key={idx2}>{part.value}</React.Fragment>
                  })
                }
                return <div className="card" key={versione.id}>
                  <div className="card-header">
                    <h6>{nice_date(versione.data)}</h6>
                  </div>
                  <div className="card-body">
                    <h6 className="page-header">Testo renderizzato</h6>
                    <MdMath source={versione.testo} />
                    {elem &&
                      <>
                        <h6 className="page-header">Sorgente con modifiche evidenziate</h6>
                        {elem}
                      </>
                    }
                  </div>
                </div>
              })}
            </Popover.Content>
          </Popover>
        }}
      </Overlay>
    </>
  );
}
